class WindowCommunication {
  constructor(channelName, options = {}) {
    this.channelName = channelName
    this.options = {
      timeout: 2000,
      ...options,
    }
    this.channel = null
    this.handlers = new Map()
    this.init()
  }

  init() {
    try {
      this.channel = new BroadcastChannel(this.channelName)
      this.channel.addEventListener('message', this.handleMessage.bind(this))
      this.communicationType = 'broadcast'
    } catch (error) {
      window.addEventListener('storage', this.handleStorage.bind(this))
      this.communicationType = 'storage'
    }
  }

  handleMessage(event) {
    const type = Object.prototype.hasOwnProperty.call(event.data, 'type') ? event.data.type : this.channelName
    const data = Object.prototype.hasOwnProperty.call(event.data, 'data') ? event.data.data : event.data
    const handlers = this.handlers.get(type) || []
    handlers.forEach((handler) => handler(data))
  }

  send(data) {
    if (this.communicationType === 'broadcast') {
      // 直接发送数据，不再包装 type
      this.channel.postMessage(data)
    } else {
      const key = `${this.channelName}`
      localStorage.setItem(key, JSON.stringify({ data }))
      setTimeout(() => {
        localStorage.removeItem(key)
      }, this.options.timeout)
    }
  }

  handleStorage(event) {
    if (event.key?.startsWith(this.channelName)) {
      try {
        const { type, data } = JSON.parse(event.newValue || '{}')
        const handlers = this.handlers.get(type) || []
        handlers.forEach((handler) => handler(data))
      } catch (error) {
        console.error('解析 Storage 消息失败:', error)
      }
    }
  }

  on(type, handler) {
    if (!this.handlers.has(type)) {
      this.handlers.set(type, [])
    }
    this.handlers.get(type).push(handler)
  }

  off(type, handler) {
    if (!this.handlers.has(type)) return
    const handlers = this.handlers.get(type)
    const index = handlers.indexOf(handler)
    if (index !== -1) {
      handlers.splice(index, 1)
    }
  }

  destroy() {
    if (this.channel) {
      this.channel.close()
    } else {
      window.removeEventListener('storage', this.handleStorage.bind(this))
    }
    this.handlers.clear()
  }
}

export default WindowCommunication
